const HOST_API = process.env.REACT_APP_HOST_API;

export const CHANNELS = HOST_API + "/Channels";
